import { TAXDOWN_ASSETS_DOMAIN } from './domains';

export type LottiePath = {
  [key: string]: string;
};
export const lottiesPaths: LottiePath = {
  GREEN_KITE: `${TAXDOWN_ASSETS_DOMAIN}/lottie/green-kite.json`,
  DASHBOARD_DATA_RETRIEVAL: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dashboard/mx_dashboard_sin_empezar.json`,
  SHEETS: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dashboard_sheets.json`,
  DG_ERROR: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dg-error.json`,
  ON_REVIEW: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dashboard/mx_dashboard_revisando.json`,
  RESULT_TRANSITION: `${TAXDOWN_ASSETS_DOMAIN}/lottie/scanner.json`,
  ALGORITHM: `${TAXDOWN_ASSETS_DOMAIN}/lottie/algoritmo.json`,
  DEVOLUTION: `${TAXDOWN_ASSETS_DOMAIN}/lottie/devolución.json`,
  SUBMIT_ON_TIME: `${TAXDOWN_ASSETS_DOMAIN}/lottie/presentar_a_tiempo.json`,
  TEN_DAYS: `${TAXDOWN_ASSETS_DOMAIN}/lottie/10dias.json`,
  SAT_ERROR: `${TAXDOWN_ASSETS_DOMAIN}/lottie/sat_error.json`,
  ERROR_LOTTIE: `${TAXDOWN_ASSETS_DOMAIN}/lottie/error.json`,
  VALIDATION: `${TAXDOWN_ASSETS_DOMAIN}/lottie/validation.json`,
  DISCARDED: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dashboard/mx_dashboard_error.json`,
  DISCARDED_NOT_MANDATORY: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dashboard/mx_dashboard_presentada.json`,
  AUTH_ON_BOARDING: `${TAXDOWN_ASSETS_DOMAIN}/lottie/on_boarding_3.json`,
  FILTER_DATA: `${TAXDOWN_ASSETS_DOMAIN}/lottie/filtering_data.json`,
  SPLASH_SCREEN: `${TAXDOWN_ASSETS_DOMAIN}/lottie/logo_loader.json`,
  SUBMITTED: `${TAXDOWN_ASSETS_DOMAIN}/lottie/submitted.json`,
  FILED_NOT_RETURN: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dashboard/mx_dashboard_presentada.json`,
  FILED: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dashboard/mx_dashboard_sat_no_ha_respondido.json`,
  WARNING: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dashboard/mx_dashboard_dashboard_warning.json`,
  MORE_INFO: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dashboard/mx_dashboard_falta_info.json`,
  NOT_MANDATORY: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dashboard_nomandatory.json`,
  PAID: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dashboard/mx_dashboard_presentada.json`,
  CONFETI: `${TAXDOWN_ASSETS_DOMAIN}/lottie/confetti.json`,
  DG_FORM: `${TAXDOWN_ASSETS_DOMAIN}/lottie/dg/dg_nif_animation.json`,
};

export const plansLotties = {
  FLEX: `${TAXDOWN_ASSETS_DOMAIN}/lottie/plans/flex/success.json`,
  FLEX_LITE: `${TAXDOWN_ASSETS_DOMAIN}/lottie/plans/flex/success.json`,
  PRO: `${TAXDOWN_ASSETS_DOMAIN}/lottie/plans/pro_mx/success.json`,
  PRO_PLUS: `${TAXDOWN_ASSETS_DOMAIN}/lottie/plans/pro_mx/success.json`,
  FULL: `${TAXDOWN_ASSETS_DOMAIN}/lottie/plans/full_mx/success.json`,
  FULL_PLUS: `${TAXDOWN_ASSETS_DOMAIN}/lottie/plans/full_mx/success.json`,
};

export const emptyImagePath = {
  EMPTY_INVESTMENTS: `${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/graph_bars_m.png`,
  EMPTY_JOBS: `${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/Worker_card_m.png`,
  EMPTY_OTHER_INCOME: `${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/fractions_m.png`,
};
